/**
 * WSStockNotifAssembly.Shopping - back-in-stock sign-up on ASSEMBLY item pages (2026-10-23). ES5 (the extension compiler minifies it).
 *
 * WHY. The SuiteCommerce Stock Notifications extension (1.1.12) mounts its product-page form only when itemtype === 'InvtPart', and its
 * "should the form show" service loads the item as an inventory item, which throws for an assembly. Well-Shod sells about 700 assemblies on
 * the web. The nightly email job (our copy, script 3451) accepts assemblies since the same change; see docs/STOCK-NOTIFICATIONS.md.
 *
 * WHAT IT DOES. On the product page of a non-grid Assembly item it mounts the Stock Notifications extension's OWN PDP view in the same slot
 * ('Product.Stock.Info', index 10), with one method replaced: isStockNotificationVisible() reads the item's out-of-stock behavior from the
 * item already on the page instead of calling the inventory-only service. Shown for the same two behaviors that service accepts:
 * "Disallow back orders but display out-of-stock message" (DISABLE) and "Allow back orders but display out-of-stock message" (ENABLE).
 * Everything else (template, subscribe form, subscribe service, My Account list, email) is the extension's own code, untouched.
 * It also re-renders the stock slot once on a direct landing, where the platform leaves its extension views unrendered (see below).
 *
 * FAILS CLOSED. The Stock Notifications modules are looked up at mount time; if that extension is missing or renamed, nothing is mounted
 * and the page is unaffected. Every call is in try/catch.
 */
define('WSStockNotifAssembly.Shopping', ['require'], function (require) {
    'use strict';

    var SHOW_BEHAVIORS = [
        'DISABLE', 'Disallow back orders but display out-of-stock message',
        'ENABLE', 'Allow back orders but display out-of-stock message'
    ];

    function showsForm(item) {
        var b = item && item.outofstockbehavior;
        for (var i = 0; i < SHOW_BEHAVIORS.length; i++) { if (SHOW_BEHAVIORS[i] === b) { return true; } }
        return false;
    }

    // DIRECT LANDINGS (measured 2026-10-24). When a shopper opens a product page straight from a link or search result, the extension
    // views in the 'Product.Stock.Info' slot (this one, AND the Stock Notifications extension's own form on inventory items) are
    // constructed but never rendered: childViewInstance has no element. In-site navigation renders them. Re-rendering the slot by hand
    // on a direct landing produced exactly the in-site-navigation result on 5 pages (forms and Inventory Display text). So after the
    // product page shows, if any view in the slot has no element or is off the page, re-render the slot once.
    function reattachStockSlot(container) {
        try {
            var layout = container.getLayout && container.getLayout();
            var view = layout && layout.currentView;
            var slot = view && view.childViewInstances && view.childViewInstances['Product.Stock.Info'];
            if (!slot || typeof view.renderChild !== 'function') { return; }
            for (var name in slot) {
                if (Object.prototype.hasOwnProperty.call(slot, name)) {
                    var inst = slot[name] && slot[name].childViewInstance;
                    if (inst && (!inst.el || !document.body.contains(inst.el))) {   // never attached: no element yet, or not on the page
                        view.renderChild('Product.Stock.Info');
                        return;
                    }
                }
            }
        } catch (e) {
            if (window.console) { console.log('WSStockNotifAssembly: stock slot not re-rendered', e); }
        }
    }

    // SIGN-UP LINKS (Quick View 2026-10-26, search/category tiles 2026-10-29, Jessica). Neither the Quick View popup nor the result tiles
    // carry a sign-up form, for any item type; they show "Out of Stock" only. Both get one link under the stock message that opens the
    // full product page, where the form is. Same rule as the form: out of stock AND a behavior that displays the out-of-stock message,
    // any item type. Following a link opens the form on arrival (openFormOnArrival), so the shopper does not have to find it.
    var OPEN_KEY = 'wsStockNotifOpen';

    function notifyLink(item, inStock) {
        var url = item && (item.keyMapping_url || (item.urlcomponent ? '/' + item.urlcomponent : ''));
        if (!url || inStock !== false || !showsForm(item)) { return null; }
        var a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('data-ws-stocknotif-link', '1');
        a.style.cssText = 'display:inline-block;margin-top:8px;text-decoration:underline;';
        a.appendChild(document.createTextNode('Get Notified When Available'));
        a.addEventListener('click', function () {
            try { window.sessionStorage.setItem(OPEN_KEY, String(item.internalid)); } catch (e) { /* storage blocked: the link still works */ }
        });
        return a;
    }

    function quickViewLinkView(Backbone, pdp) {
        var View = Backbone.View.extend({
            render: function () {
                var stock = pdp.getStockInfo ? pdp.getStockInfo() : null;
                var a = notifyLink(pdp.getItemInfo().item, stock ? stock.isInStock : null);
                this.el.innerHTML = '';
                if (a) { a.setAttribute('data-ws-stocknotif-quickview-link', '1'); this.el.appendChild(a); }
                return this;
            }
        });
        return new View();
    }

    // The tile's item arrives through contextData (measured 2026-10-29: the constructor gets no model; contextData.item() carries
    // internalid, isinstock, outofstockbehavior, urlcomponent and keyMapping_url on www.well-shod.com search results).
    function tileLinkView(Backbone) {
        var View = Backbone.View.extend({
            contextDataRequest: ['item'],
            render: function () {
                var raw = this.contextData && this.contextData.item && this.contextData.item();
                var item = raw && typeof raw.toJSON === 'function' ? raw.toJSON() : raw;
                var a = notifyLink(item, item ? item.isinstock : null);
                this.el.innerHTML = '';
                if (a) { a.setAttribute('data-ws-stocknotif-tile-link', '1'); this.el.appendChild(a); }
                return this;
            }
        });
        return new View();
    }

    // Arrived from one of the links above: open the product page's sign-up form once. Runs after reattachStockSlot's second pass.
    function openFormOnArrival(pdp) {
        try {
            var want = window.sessionStorage.getItem(OPEN_KEY);
            if (want === null || want !== String(pdp.getItemInfo().item.internalid)) { return; }
            window.sessionStorage.removeItem(OPEN_KEY);
            var toggle = document.querySelector('[data-action="stocknotifications-dropdown-show"]');
            var email = document.querySelector('.stock-notifications-pdp input[name="email"], form input[name="email"]');
            if (!toggle) { return; }
            if (!email || email.offsetParent === null) { toggle.click(); }
            if (typeof toggle.scrollIntoView === 'function') { toggle.scrollIntoView({ block: 'center' }); }
        } catch (e) {
            if (window.console) { console.log('WSStockNotifAssembly: form not opened on arrival', e); }
        }
    }

    return {
        mountToApp: function mountToApp(container) {
            var pdp, PdpView, PdpModel;
            try {
                pdp = container.getComponent('PDP');
                if (!pdp) { return; }
                PdpView = require('SuiteCommerce.StockNotifications.PDP.View').PdpView;
                PdpModel = require('SuiteCommerce.StockNotifications.PDP.Model').PdpModel;
                if (!PdpView || !PdpModel) { return; }
            } catch (e) {
                if (window.console) { console.log('WSStockNotifAssembly: Stock Notifications extension not available', e); }
                return;
            }
            pdp.addChildViews(pdp.PDP_FULL_VIEW, {
                'Product.Stock.Info': {
                    'WSStockNotifAssembly.PDP': {
                        childViewIndex: 10,
                        childViewConstructor: function () {
                            try {
                                var item = pdp.getItemInfo().item;
                                if (item.itemtype !== 'Assembly' || item.keyMapping_showGrid) { return null; }
                                var view = new PdpView({ pdp: pdp, container: container, model: new PdpModel() });
                                view.isStockNotificationVisible = function () { return showsForm(pdp.getItemInfo().item); };
                                return view;
                            } catch (e) {
                                if (window.console) { console.log('WSStockNotifAssembly: not mounted', e); }
                                return null;
                            }
                        }
                    }
                }
            });
            try {
                var Backbone = require('Backbone');
                pdp.addChildViews(pdp.PDP_QUICK_VIEW, {
                    'Product.Stock.Info': {
                        'WSStockNotifAssembly.QuickViewLink': {
                            childViewIndex: 10,
                            childViewConstructor: function () {
                                try { return quickViewLinkView(Backbone, pdp); } catch (e) { return null; }
                            }
                        }
                    }
                });
            } catch (e) {
                if (window.console) { console.log('WSStockNotifAssembly: quick view link not mounted', e); }
            }
            try {
                var plp = container.getComponent('PLP');
                if (plp) {
                    plp.addChildViews(plp.PLP_VIEW, {
                        'ItemViews.Stock': {
                            'WSStockNotifAssembly.TileLink': {
                                childViewIndex: 10,
                                childViewConstructor: function () {
                                    try { return tileLinkView(require('Backbone')); } catch (e) { return null; }
                                }
                            }
                        }
                    });
                }
            } catch (e) {
                if (window.console) { console.log('WSStockNotifAssembly: tile link not mounted', e); }
            }
            try {
                pdp.on('afterShowContent', function () {
                    setTimeout(function () { reattachStockSlot(container); }, 0);       // views usually exist by now
                    setTimeout(function () { reattachStockSlot(container); }, 1500);    // and if not, by now; a fully rendered slot is a no-op
                    setTimeout(function () { openFormOnArrival(pdp); }, 2000);
                });
            } catch (e) {
                if (window.console) { console.log('WSStockNotifAssembly: afterShowContent not hooked', e); }
            }
        }
    };
});
